// extracted by mini-css-extract-plugin
export default {"fieldLoader":"FieldLoader_fieldLoader__RvQAi","spin":"FieldLoader_spin__ujLoN","opacity25":"FieldLoader_opacity25__Fts44","opacity75":"FieldLoader_opacity75__oP-cU"};